import React, { useCallback, useEffect, useMemo } from 'react'
import { RentalMarketSection } from '../../../RentalMarketSection'
import { createStaticRentalMarketService } from '../../../RentalMarketSection/StaticRentalMarketService'
import { useAnalysisMode } from '../../contexts/AnalysisModeContext'
import { useAnalysisServices } from '../../contexts/AnalysisServicesContext'
import { useAnalysisMapSectionData } from '../../contexts/MapSectionDataContext'

/**
 * Shared RentalMarketTab used by both main and public apps.
 *
 * - Main app: gets rentalMarketService from
 *   getSectionData('rentalMarketService')
 * - Public app: creates static service from entity
 *   market_aggregations data
 */
export const RentalMarketTab: React.FC = () => {
  const { entity, userId, readOnly } = useAnalysisMode()
  const { getSectionData, updateSectionData } = useAnalysisServices()
  const { setActiveSection } = useAnalysisMapSectionData()

  useEffect(() => {
    setActiveSection('rental_market')
  }, [setActiveSection])

  const service = useMemo(() => {
    if (readOnly) {
      const marketData =
        entity?.market_aggregations ||
        entity?.marketAggregations ||
        entity?.rental_market ||
        null
      return createStaticRentalMarketService(marketData)
    }
    return getSectionData('rentalMarketService')
  }, [readOnly, entity, getSectionData])

  // Read saved filters from entity
  const savedFilters = entity?.rentalMarketFilters

  const handleFilterChange = useCallback(
    (filters: any) => {
      if (!entity || !userId) return
      updateSectionData('rentalMarket', entity, userId, { filters })
    },
    [entity, userId, updateSectionData]
  )

  if (!service || !entity) return null

  return (
    <RentalMarketSection
      entity={entity}
      service={service}
      readOnly={readOnly}
      initialLocationType={savedFilters?.locationType}
      initialPropertyType={savedFilters?.propertyType}
      onFilterChange={readOnly ? undefined : handleFilterChange}
    />
  )
}
